<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <AvisoEvaluacionDocente></AvisoEvaluacionDocente>
            <v-flex md6 sm6 xs12>
                <perfil></perfil>
            </v-flex>
            <v-flex md6 sm6 xs12>
                <mensajes></mensajes>
                <AvisoEstudiantes></AvisoEstudiantes>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import Mensajes from '@/components/Mensajes'
  import Perfil from '@/components/Perfil'
  import AvisoEstudiantes from '@/components/views/AvisoEstudiantes'
  import AvisoEvaluacionDocente from '@/components/views/AvisoEvaluacionDocente'

  export default {
    name: 'HomePage',
    components: {AvisoEvaluacionDocente, AvisoEstudiantes, Perfil, Mensajes}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/home/HomePage.vue